import React from 'react';
import { IoMdCloseCircle } from 'react-icons/io';


interface DeviceModalPopUpProps {
    show: boolean;
    message: string;
    message1: string;
    icon: React.ReactNode;
    onConfirm: () => void;
    onCancel: () => void;
}

const DeviceModalPopUp: React.FC<DeviceModalPopUpProps> = ({
    show,
    message,
    message1,
    icon,
    onConfirm,
    onCancel,
}) => {
    if (!show) {
        return null;
    }

    return (
        <div className="fixed inset-0 flex items-center justify-center bg-gray-500 bg-opacity-75 z-50">
            <div className="bg-white p-6 rounded-lg shadow-lg text-center relative w-80 h-48">
                <button
                    className="absolute top-0 right-0 mt-2 mr-2 !text-black"
                    onClick={onCancel}
                    aria-label="close"
                >
                    <IoMdCloseCircle className="!text-lg" />
                </button>
                <div className="mt-2 mx-8">
                    <div className='mb-3 flex justify-content-center'>
                        {icon}
                    </div>
                    <p className="text-black font-bold text-sm">
                        {message}
                    </p>
                    <p className='text-light_grey text-sm'>
                        {message1}
                    </p>
                </div>
            </div>
        </div>
    );
};

export default DeviceModalPopUp;
